namespace TabAurous.Scheme {
    export interface SchemeMasterForm {
        SchemeType: Serenity.LookupEditor;
        SchemeCode: Serenity.StringEditor;
        SchemeAmount: Serenity.DecimalEditor;
        Frequency: Serenity.LookupEditor;
        Tenure: Serenity.IntegerEditor;
        BonusType: Serenity.LookupEditor;
        BonusValue: Serenity.DecimalEditor;
        AllowCancellation: Serenity.BooleanEditor;
        CancellationCharge: Serenity.DecimalEditor;
        Description: Serenity.StringEditor;
    }

    export class SchemeMasterForm extends Serenity.PrefixedContext {
        static formKey = 'Scheme.SchemeMaster';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SchemeMasterForm.init)  {
                SchemeMasterForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.BooleanEditor;

                Q.initFormType(SchemeMasterForm, [
                    'SchemeType', w0,
                    'SchemeCode', w1,
                    'SchemeAmount', w2,
                    'Frequency', w0,
                    'Tenure', w3,
                    'BonusType', w0,
                    'BonusValue', w2,
                    'AllowCancellation', w4,
                    'CancellationCharge', w2,
                    'Description', w1
                ]);
            }
        }
    }
}
